module.exports = {
          srcSet: __webpack_public_path__ + "images/2006-426dada13f0ebad942ce38a7250a0dc5-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/2006-4789ebd3b14b734ad03413eb6f6c0377-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/2006-426dada13f0ebad942ce38a7250a0dc5-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/2006-4789ebd3b14b734ad03413eb6f6c0377-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/2006-426dada13f0ebad942ce38a7250a0dc5-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/2006-426dada13f0ebad942ce38a7250a0dc5-320.jpg"},
          
          width: 320,
          height: 251
        }